"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bottom_block_dot_1 = require("./bottom-block.dot");
exports.bottomBlockTemplate = bottom_block_dot_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/bottom-block/templates/index.js
// module id = 154
// module chunks = 0